<template>
  <div :style="styleObject">
    <slot #content>

    </slot>
  </div>
</template>

<script>
export default {
  name: 'VOverlay',
  props: {
    styleObject: {
      type: Object,
      default() {
        return {
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          zIndex: '2',
          top: '0'
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
